<template>
  <v-card text>
    <v-card color="grey lighten-4" text tile>
      <v-toolbar color="primary" dark dense text>
        <v-toolbar-title>Select Your Ad Account</v-toolbar-title>
      </v-toolbar>
      <v-row v-if="adAccounts.length" class="ma-0">
        <v-col
          cols="6"
          class="d-flex"
          v-for="adAccount in adAccounts"
          :key="adAccount.id"
          @click="selectAdAccount(adAccount)"
        >
          <v-card
            width="100%"
            class="pointer d-flex"
            ripple
            :color="getAdaccountColor(adAccount.id)"
          >
            <v-card-text>
              <div class="body-2">
                {{ adAccount.name }}
              </div>
              <div>{{ adAccount.id.slice(4) }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else class="ma-0">
        <v-col cols="12">
          <v-card width="100%">
            <v-card-text class="text-md-center">
              We could not find any Facebook ad accounts
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card color="grey lighten-4" text tile>
        <v-toolbar color="primary" dark dense text>
          <v-toolbar-title>Select Your Page</v-toolbar-title>
        </v-toolbar>
        <v-row v-if="accounts.length" class="ma-0">
          <v-col
            cols="6"
            class="d-flex"
            v-for="account in accounts"
            :key="account.id"
            @click="selectAccount(account)"
          >
            <v-card
              width="100%"
              class="pointer d-flex"
              ripple
              :color="getColor(account.id)"
            >
              <v-card-text>
                <div class="body-2">
                  {{ account.name }}
                </div>
                <div>{{ account.id.slice(4) }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else class="ma-0">
          <v-col cols="12">
            <v-card width="100%">
              <v-card-text class="text-md-center">
                We could not find any Facebook pages
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    <div class="ml-3">
      <v-checkbox
        v-model="terms"
        :rules="[v => !!v || 'You must agree to continue!']"
        label="I agree to Outfox AI Terms of Service and Privacy Policy"
      />
    </div>
    <v-card-actions>
      <v-btn
        text
        @click.native="previous"
      >
        Previous
      </v-btn>
      <v-spacer/>
      <div
        v-if="terms && !existingCampaign"
        @click="moveToGettingStarterPreview"
        class="text-link"
      >
        Skip, and set up later
      </div>
      <div
        class="text-link"
        v-else-if="!terms && !existingCampaign"
      >
        Skip, and set up later
      </div>
      <v-spacer/>
      <v-btn
        text
        color="primary"
        :disabled="!valid"
        @click.native="next"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import lodash from 'lodash'
export default {
  name: 'StepperContentThree',
  data () {
    return {
      terms: false,
      selectedAdaccount: false,
      selectedAccount: false
    }
  },
  props: {
    existingCampaign: {
      type: Object,
      default: null
    },
    newClientCreating: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      advertisers: 'getAdvertisers'
    }),
    accounts () {
      if (!this.user) return []
      return this.user.accounts
    },
    adAccounts () {
      if (!this.user) return []
      return this.user.adAccounts
    },
    valid () {
      if (this.existingCampaign && this.terms) return true
      if (!this.terms || !this.selectedAdaccount || !this.selectedAccount) return false
      return true
    },
    selectedAdvertiser () {
      if (!this.user) return false
      return this.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
    }
  },
  methods: {
    moveToGettingStarterPreview () {
      this.$router.push('setup-checklist/preview')
    },
    selectAccount (account) {
      if (this.existingCampaign) {
        this.$store.dispatch('showNotification', {
          type: 'warning',
          message: ['You can not change this settings']
        })
        return false
      }
      const copy = lodash.cloneDeep(this.selectedAdvertiser)
      copy.data.fb_page_id = account.id
      this.selectedAccount = true
      this.$store.dispatch('updateAdvertiser', copy)
    },
    selectAdAccount (adAccount) {
      if (this.existingCampaign) {
        this.$store.dispatch('showNotification', {
          type: 'warning',
          message: ['You can not change this settings']
        })
        return false
      }
      const copy = lodash.cloneDeep(this.selectedAdvertiser)
      copy.data.ad_account = adAccount.id
      this.selectedAdaccount = true
      this.$store.dispatch('updateAdvertiser', copy)
    },
    previous () {
      this.$emit('setPage', 2)
    },
    next () {
      if (this.newClientCreating) {
        this.createNewClient()
        return false
      }
      this.$emit('showCongrats')
    },
    createNewClient () {
      this.$store.dispatch('fetchAdvertisers')
      this.$store.dispatch('showNotification', {
        type: 'success',
        message: ['You successfully added a new client']
      })
      this.$emit('showCongrats')
    },
    getColor (id) {
      if (this.selectedAdvertiser && this.selectedAdvertiser.data.fb_page_id === id) return 'green lighten-3'
      return ''
    },
    getAdaccountColor (id) {
      if (this.selectedAdvertiser && this.selectedAdvertiser.data.ad_account === id) return 'green lighten-3'
      return ''
    }
  }
}
</script>
